/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Button, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

export interface IShowContactInfoInput {
    canEdit: boolean;
    email: string;
    customerRequisition:string;
    customerRequisitionLocked:boolean;
    customerReference: string;
    customerReferenceLocked: boolean;
    customerMessage: string;
    resources: {
        editBtnLabel: string;
    };
    onEdit(): void;
}

export interface IShowContactInfo {
    showInfoProps: INodeProps;
    email: React.ReactNode;
    customerRequisition: React.ReactNode;
    customerReference: React.ReactNode;
    customerMessage: React.ReactNode;
    editButton?: React.ReactNode;
}

const getContactInfo = ({
    canEdit,
    email,
    customerRequisition,
    customerRequisitionLocked,
    customerReference,
    customerReferenceLocked,
    customerMessage,
    resources: {
        editBtnLabel
    },
    onEdit
}: IShowContactInfoInput): IShowContactInfo => ({
    showInfoProps: { className: 'ms-checkout-guest-profile__selected-item' },
    email: <span className='ms-checkout-guest-profile__selected-email'>{email}</span>,
    customerRequisition: (
        <div className={classnames('ms-checkout-guest-profile__customer-requisition', { 'read-only': customerRequisitionLocked })}>
            {customerRequisition}
        </div>
    ),
    customerReference: (
        <div className={classnames('ms-checkout-guest-profile__customer-reference', { 'read-only': customerReferenceLocked })}>
            {customerReference}
        </div>
    ),
    customerMessage: <div className='ms-checkout-guest-profile__customer-message'>{customerMessage}</div>,
    editButton: canEdit && (
        <Button className='ms-checkout-guest-profile__btn-edit' title={editBtnLabel} color='link' onClick={onEdit}>
            {editBtnLabel}
        </Button>
    )
});

export default getContactInfo;
